/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import "./rewardDetails.scss";
import GroupWrapItem from "./friendsCard";
import Pagination from "./pagination";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DefaultHearder from "@/assets/icons/default-avatar.svg";
import NoData from "./noData";
import { useState, useEffect } from "react";
import { getTaskProcessDetailApi } from "@/app/csr-src/apis/invitePolitely/invitePolitely.api";
import UKPageLoading from "@/components/UKPageLoading";
import { useTranslation } from "@/i18n/client";

export default function RewardDetails({ isCodeType, activityId, taskProcess, currency, onInvitingCheck }: any) {
  const [userList, setUserList] = useState([]);
  const [currentSelected, setCurrentSelected] = useState("SUCCESS"); // SUCCESS  PENDING
  const [couponInfo, setCouponInfo] = useState({
    receiveQty: 0,
    awardType: 1,
    coupon: {
      discount: 0,
      quota: 0,
      couponType: 1,
    },
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const pageSize = 20;
  const { t } = useTranslation();

  const getData = async () => {
    setIsLoading(true);
    const params = {
      activityId,
      processType: currentSelected === "SUCCESS" ? 2 : 1,
      currentPage,
      pageSize,
    };
    if (activityId) {
      const res: any = await getTaskProcessDetailApi(params);
      if (res?.code == "200") {
        const { data, total } = res?.data || [];
        if (res?.data?.data) {
          setUserList(res.data.data);
        } else {
          setUserList([]);
        }
        setCurrentPage(currentPage);
        setTotal(total);
        setIsLoading(false);
      }
    }
    setIsLoading(false);
  };

  const pagesChangeHandler = (val: number) => {
    setCurrentPage(val);
  };
  const tabChange = (state: string) => {
    setUserList([]);
    setIsLoading(true);
    setCurrentPage(1);
    switch (state) {
      case "SUCCESS":
        setCurrentSelected("SUCCESS");
        break;
      case "PENDING":
        setCurrentSelected("PENDING");
        break;
      default:
        setCurrentSelected("SUCCESS");
    }
  };

  useEffect(() => {
    let info = {
      receiveQty: 0,
      awardType: 1,
      coupon: {
        discount: 0,
        quota: 0,
        couponType: 1,
      },
    };
    if (
      taskProcess &&
      taskProcess.receiveAwards &&
      taskProcess.receiveAwards[0] &&
      taskProcess.receiveAwards[0].awards &&
      taskProcess.receiveAwards[0].awards[0]
    ) {
      info = taskProcess.receiveAwards[0].awards[0];
    }
    setCouponInfo({
      receiveQty: info.receiveQty,
      awardType: info.awardType,
      coupon: info.coupon,
    });
  }, [taskProcess]);

  useEffect(() => {
    getData();
  }, [currentPage]);

  useEffect(() => {
    getData();
  }, [currentSelected]);

  if (userList?.length <= 0) {
    return;
  } else {
    return (
      <div className="rewardDetailWrap">
        {!isCodeType && (
          <div className="titleTabFloor">
            <div className="titleTabBox">
              <div className={`title ${currentSelected === "SUCCESS" ? "selected" : ""}`} onClick={() => tabChange("SUCCESS")}>
                <div>
                  {`${t("profile.inviteFriend.success")} `}({taskProcess?.success ? taskProcess.success : 0})
                </div>
                <div className="line"></div>
              </div>
              <div className={`title ${currentSelected === "PENDING" ? "selected" : ""}`} onClick={() => tabChange("PENDING")}>
                <div>
                  {`${t("profile.inviteFriend.pending")} `}({taskProcess?.pending ? taskProcess.pending : 0})
                </div>
                <div className="line"></div>
              </div>
            </div>
          </div>
        )}
        {currentSelected === "SUCCESS" && userList?.length > 0 ? (
          <>
            {isCodeType && (
              <Box sx={{ textAlign: "center", color: "#1a1a1a", fontSize: "18px", fontWeight: 700 }}>{t("profile.inviteFriend.couponsEarned")}</Box>
            )}
            <div className="couponFloor">
              <div className={`couponCard ${couponInfo?.coupon.couponType === 1 ? "redTheme" : "greenTheme"}`}>
                {couponInfo?.coupon.couponType === 1 ? (
                  <div
                    className="font-big fontJD"
                    dangerouslySetInnerHTML={{
                      __html: t("coupon.off_over", { currency: currency, n: couponInfo?.coupon.discount, m: couponInfo?.coupon.quota }),
                    }}
                  />
                ) : (
                  <div className="font-big fontJD">
                    <span>
                      {currency}
                      {couponInfo?.coupon?.quota || 0}{" "}
                    </span>
                    <span className="font-small  ml12">{t("coupon.shippingOff")}</span>
                  </div>
                )}
              </div>
              <span className="font-middle20 ml">x</span>
              <span className="font-middle28 fontJD">{couponInfo?.receiveQty ? couponInfo?.receiveQty : 0}</span>
            </div>
          </>
        ) : null}

        {isLoading && (
          <div className="loadPage">
            <UKPageLoading />
          </div>
        )}
        {!isLoading && (
          <>
            {isCodeType && userList.length > 0 && (
              <Box
                sx={{
                  marginTop: "28px",
                  textAlign: "center",
                  color: "#1a1a1a",
                  fontSize: "18px",
                  fontWeight: 700,
                }}
              >
                {t("profile.inviteFriend.friendsReferred")}
              </Box>
            )}
            <div className="teammateFloor">
              <div className="groupWrap">
                {currentSelected === "SUCCESS" && !isCodeType && (
                  <div className="groupWrapItem">
                    <DefaultHearder className="headerIcon" />
                    <p className="name">{t("profile.inviteFriend.waitInviting")}</p>
                    <Button variant="outlined" onClick={onInvitingCheck} className="inviteBtn">
                      {t("profile.inviteFriend.keepInviting")}
                    </Button>
                  </div>
                )}
                {userList.map((v: any, i: number) => {
                  return <GroupWrapItem status={currentSelected} key={i} data={v} />;
                })}
              </div>
              {!userList.length && <NoData msg={t("common.pageStatus.nothing")} />}
            </div>
          </>
        )}
        <div className="pageWrap">
          {total && !isLoading ? <Pagination currentPage={currentPage} totalPages={Math.ceil(total / 20)} handlePageChange={pagesChangeHandler} /> : null}
        </div>
      </div>
    );
  }
}
